import { GMMConfig, Plugin } from "./types";
import { HttpClient } from "./http";
import { SessionsResource } from "./resources/sessions";
import { WebhooksResource } from "./resources/webhooks";

class GMMGateway {
  public http: HttpClient;
  public sessions: SessionsResource;
  public webhooks: WebhooksResource;

  constructor(private config: GMMConfig) {
    if (!config.apiKey) throw new Error("API key is required");

    if (!config.apiSecret) throw new Error("API Secret is required");

    if (!config.origin) throw new Error("Origin is required");

    this.http = new HttpClient(config);
    this.sessions = new SessionsResource(this.http);
    this.webhooks = new WebhooksResource(config);
  }

  use(plugin: Plugin) {
    plugin.setup(this);
  }
}

export { GMMGateway };
